import React, { useEffect, useState } from "react";
import Box from "../Box";
import styles from "./styles/QDrawer.module.css";
import log from "cslog";

function QDrawer({ db, gs, device, action, setAction }) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (action.type === "drawer") {
            const timer = setTimeout(() => {
                setOpen(true);
            }, 1);
            return () => clearTimeout(timer);
        }
    }, [action]);

    const closeDrawer = () => {
        setOpen(false);
        setTimeout(() => {
            setAction({
                type: "none",
            });
        }, 300);
    };

    const width = 80;

    return (
        <div className={styles.wrapper}>
            <div
                className={styles.drawer}
                style={{
                    width: "80%",
                    // put this line in root div
                    transform: open ? "translateX(0%)" : "translateX(-100%)",
                    height: "100%",
                }}
            >
                {/* <h3>Qureal Drawer</h3> */}
                <Box id="qdrawer" db={db} device={device} gs={gs} />
                <div className={styles.closeBtn} onClick={closeDrawer}>
                    <i className="fas fa-times" />
                </div>
            </div>
            <div className={styles.outArea} onClick={closeDrawer}></div>
        </div>
    );
}

export default QDrawer;
